import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ServiceImg from "../../img/Topsection/pexels-mikhail-nilov-7988238.jpg";
import { Link } from "gatsby";
import ProjectCard from "./ProjectCard";
import LeftNav from "./LeftNav";
import WhyScrumanac from "./WhyScrumanac";
import CollaborationModel from "./CollaborationModels";
import DedicatedTeam from "./DedicatedTeam";
import { StaticQuery, graphql } from "gatsby";
import TopSection from "./TopSection";

const ServiceSection = () => {
  const [pageHeight, setPageHeight] = useState(0);

  useEffect(() => {
    function setHeight() {
      setPageHeight(parseInt(window.pageYOffset));
    }
    window.addEventListener("scroll", setHeight);
  }, []);

  return (
    <StaticQuery
      query={graphql`
        query ServicePageQuery {
          markdownRemark(
            frontmatter: { title: { eq: "Dedicated Team Services" } }
          ) {
            id
            frontmatter {
              title
              subtitle
              background {
                publicURL
              }
              description
              data {
                dedicatedModel {
                  image {
                    publicURL
                  }
                  title
                  text
                }
                customApproach {
                  title
                  text
                }
                topSection {
                  image {
                    childImageSharp {
                      resize(width: 3080, jpegProgressive: true, quality: 100) {
                        src
                        tracedSVG
                        width
                        height
                        aspectRatio
                        originalName
                      }
                    }
                  }
                  title
                  text
                }
                whyScrumanac {
                  title
                  text
                }
                collabModels {
                  title
                  projectDuration
                  teamInvolvment
                  bestScenario
                  trailPeriod
                  cost
                  button
                }
              }
            }
          }
        }
      `}
      render={(data) => (
        <div>
          <TopSection
            topData={data.markdownRemark.frontmatter.data.topSection}
          />
          <InnerContainer>
            <ContentHolder>
              <LeftNav height={pageHeight} />
              <RightNav>
                <RightSectionHeader>
                  <h3>{data.markdownRemark.frontmatter.title}</h3>
                </RightSectionHeader>
                <RightSectionTitle>
                  <h1>{data.markdownRemark.frontmatter.subtitle}</h1>
                </RightSectionTitle>
                <ServiceSub>
                  …save your budget, increase production capacity, and
                  performance.
                </ServiceSub>
                <ServiceContent>
                  <Img maxHeight={"526px"} src={ServiceImg}></Img>
                  <p>
                    Whether you power your business growth with an app or need
                    multifunctional embedded software, hiring professional
                    developers is a must. Still, many companies don’t need a
                    full-fledged, full-time development department due to
                    operational costs, administrative issues or lack of
                    long-term software development plans. If this is exactly
                    your case, outsourced services are your best and most
                    efficient management solution.
                  </p>
                  <p>
                    Your organization just needs to choose the right software
                    development subcontractor and transfer the tasks and
                    responsibilities to its team of developers. In this respect,
                    Scrumanac can offer you a dedicated professional team based
                    on your software requirements, preferences, and development
                    needs. Your organization will cut expenditures and
                    development time avoiding a tiring recruitment process. A
                    dedicated team of developers offers a unique opportunity to
                    benefit from external resources with continuous professional
                    support. There’s no need to invest in technical
                    infrastructure, personnel training, and HR-related
                    operations. Scrumanac will take care of all administrative
                    responsibilities ensuring your full control over the
                    management issues and ultimate transparency.
                  </p>
                  <p>
                    Scrumanac assists with a T&M and team extension or operates
                    as a solution provider fully responsible for the Software
                    Development Life Cycle (SDLC). As a customer-oriented
                    company, we identify the most efficient innovative
                    technologies for new products based on the business needs of
                    your organization. Scrumanac’s team offers its best
                    requirement managers, software architects, developers,
                    designers, DevOps, QAs, and other tech experts to deliver an
                    optimum software solution.
                  </p>
                </ServiceContent>
                <ServiceContent>
                  <RightSectionTitle>
                    <h2>DEDICATED TEAM Model: </h2>
                    <h2>What's in it for your Organization?</h2>
                  </RightSectionTitle>
                  <p>
                    Influenced by globalization, the new software development
                    models are much more effective than the previous,
                    location-limited approaches. Your company no longer needs to
                    be tied to a local labor market and can benefit from the
                    expertise of a remote software development team. An
                    outsourced team of developers can significantly save your
                    budget and undertake a fair share of your development and
                    management responsibilities. You can hire a fully-formed,
                    independent dedicated team or use team extension to add
                    several developers or testers to your existing resources.
                    Scrumanac’s ‘Dedicated team as a service’ can meet all and
                    any business needs as it has a wide range of advantages:
                  </p>
                  <DedicatedTeam
                    dedicatedamodelData={
                      data.markdownRemark.frontmatter.data.dedicatedModel
                    }
                  />
                </ServiceContent>
                <WhyScrumanac
                  whyData={data.markdownRemark.frontmatter.data.whyScrumanac}
                />
                <CollaborationModel
                  models={data.markdownRemark.frontmatter.data.collabModels}
                />
              </RightNav>
            </ContentHolder>
            <RelevantContainer>
              <RelevantHeaderContainer>
                <RelevantTitle>
                  <p>RELATED PROJECTS</p>
                </RelevantTitle>
                <RelevantSubTitle>All Projects</RelevantSubTitle>
              </RelevantHeaderContainer>

              <ProjectCard></ProjectCard>
            </RelevantContainer>
          </InnerContainer>
        </div>
      )}
    />
  );
};

const InnerContainer = styled.div`
  width: 100%;
  background: #f2f2f2;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  @media (max-width: 988px) {
    flex-direction: column;
  }
`;
const ContentHolder = styled.div`
  display: flex;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 980px) {
    flex-direction: column;
    max-width: 100%;
    margin-left: 0px;
    margin-right: 0px;
  }
`;

const RightNav = styled.div`
  padding-top: 2.75rem;
  width: 74%;
  @media (max-width: 980px) {
    flex-direction: column;
    align-self: center;
    width: 100%;
  }
`;

const RightSectionHeader = styled.div`
  font-size: 0.875rem;
  font-family: 'Archivo';
  font-weight: 400;
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  -webkit-opacity: 0.5;
  opacity: 0.5;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);
  filter: alpha(opacity=50);
  margin-top: 0;
  margin-bottom: 1.5rem;
`;

const RightSectionTitle = styled.div`
  font-family: 'Archivo';
  text-transform: uppercase;
  text-align: left;
  color: #3d3d3d;
  max-width: 900px;
  font-size: 1.9rem;
  line-height: 1;
  margin-bottom: 2.5rem;
  & h1 {
    font-weight: 800;
    padding: 5px;
  }
  & h2 {
    font-weight: 750;
    padding: 5px;
  }
`;

const ServiceSub = styled.div`
  font-family: 'Archivo';
  font-weight: 500;
  font-size: 1.125rem;
  color: #3d3d3d;
  margin-bottom: 1.5rem;
  line-height: 1;
  margin-bottom: 2rem;
`;

const ServiceContent = styled.div`
  font-weight: 400;
  color: #3d3d3d;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 3.5rem;

  & p {
    margin-bottom: 1rem;
    font-size: 15px;
  }
`;

const Img = styled.img.attrs((props) => ({
  src: props.src,
}))`
  max-width: 100%;
  max-height: ${(props) => (props.maxHeight ? props.maxHeight : "100%")};
  height: auto;
  display: block;
  margin: 1.5rem 0;
`;

const RelevantContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 200px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 8.25rem;
  @media (max-width: 980px) {
    margin-left: 0px;
  }
`;
const RelevantHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 980px) {
    flex-direction: column;
  }
`;

const RelevantSubTitle = styled(Link).attrs((props) => ({
  src: props.to,
}))`
  font-family: 'Archivo';
  font-weight: 800;
  font-size: 0.85rem;
  line-height: 1rem;
  color: black;
  text-transform: uppercase;
  padding-left: 3rem;
  padding-top: 30px;
  padding-bottom: 30px;
  position: relative;
  &:hover {
    color: #0066b2;
  }
`;

const RelevantTitle = styled.div`
  font-family: 'Archivo';
  font-weight: 800;
  font-size: 2.25rem;
  line-height: 1.875rem;
  flex-basis: 10%;
  color: #3d3d3d;
  text-transform: uppercase;
  & p {
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;
export default ServiceSection;
